module.exports = __webpack_public_path__ + "static/media/md-list-box.78dd3282.svg";